/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Artifacts_Download_ProgressInputs */



/**
* | output |
* | --- |
* | "Exporting {done}/{total}..." |
*
* @param {Artifacts_Download_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_download_progress = /** @type {((inputs: Artifacts_Download_ProgressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Download_ProgressInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Exportiere ${i?.done}/${i?.total}...`)
	return /** @type {LocalizedString} */ (`Exporting ${i?.done}/${i?.total}...`)
});